import { render, staticRenderFns } from "./SimTask.vue?vue&type=template&id=03288cca"
import script from "./SimTask.vue?vue&type=script&lang=js"
export * from "./SimTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports